import { MenuItem, MuiIconButton, Notification, Menu } from '@packages/shared';
import { useConfig, logger } from '@packages/utilities';
import { MenuAndroid32 } from '@packages/themes/icons';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { messages } from './messages';

type ReviewMenuProps = {
  /**
   * unique review id
   */
  id: number;
};

/**
 * Review menu to report a specific rating
 */
export const ReviewMenu = ({ id }: ReviewMenuProps) => {
  const { formatMessage } = useIntl();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openSuccessNotification, setOpenSuccessNotification] = useState(false);
  const [openErrorNotification, setOpenErrorNotification] = useState(false);
  const {
    customerRatings: {
      api: { feedback },
    },
  } = useConfig();

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleReport = async () => {
    try {
      // TODO: inject review ID when review schema updated, and add it to the fetch
      const res = await fetch(feedback, {
        body: JSON.stringify({ feedback: 'notappropriate', id }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
      });
      if (!res.ok) {
        throw new Error();
      }
      setOpenSuccessNotification(true);
    } catch (err) {
      logger.error(err, 'Error during giving report');
      setOpenErrorNotification(true);
    } finally {
      handleCloseMenu();
    }
  };

  return (
    <>
      <Notification
        open={openSuccessNotification}
        severity="success"
        autoHideDuration={3000}
        onClose={() => setOpenSuccessNotification(false)}
      >
        {formatMessage(messages.ratingReported)}
      </Notification>
      <Notification
        open={openErrorNotification}
        severity="error"
        autoHideDuration={3000}
        onClose={() => setOpenErrorNotification(false)}
      >
        {formatMessage(messages.ratingReportError)}
      </Notification>
      <MuiIconButton
        aria-label={formatMessage(messages.reportRating)}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        size="small"
        sx={{ p: 0 }}
      >
        <MenuAndroid32 />
      </MuiIconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <MenuItem
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleReport();
          }}
        >
          {formatMessage(messages.reportRating)}
        </MenuItem>
      </Menu>
    </>
  );
};
